<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">Funds Summary</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="loader-example" v-if="!ready">
      <div class="loader-bar"></div>
    </div>
    <div class="container-center lg" v-else>
      <div>
        <div class="row">
          <div class="col-sm-6" v-for="b in funds" v-bind:key="b.id">
            <router-link v-bind:to="'/funds/' + b.currency">
              <div class="panel panel-filled">
                <div class="panel-body">
                  <div class="user-content">
                    <span v-bind:class="'label ' + b.label"
                      ><img
                        :src="require(`@/assets/tokens/${b.currency}.png`)"
                        class="coin m-r-sm"
                      />
                      {{ b.currency }}
                    </span>
                    <p>Funds : {{ fixed(b.amount) }} {{ b.currency }}</p>
                    <p>Staking : {{ fixed(b.staking) }} {{ b.currency }}</p>
                    <h5 class="c-white">
                      Balance : {{ fixed(b.balance) }} {{ b.currency }}
                    </h5>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import func from "@/widgets/func";
import label from "@/widgets/label";
import admin from "@/api/admin";

export default {
  data() {
    return {
      funds: [],
      ready: false
    };
  },
  methods: {
    fixed(a) {
      return func.fixed(a);
    },
    getData() {
      admin.fundsummary().then(res => {
        res.data.forEach(e => {
          var a = label.type(e._id.type);
          e.label = a.label;

          this.funds.push(e);
        });
        this.ready = true;
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style scoped>
.container-center {
  margin: 50px auto;
}
.coin {
  width: 32px;
}
p {
  margin: 0;
}
</style>
